// extracted by mini-css-extract-plugin
module.exports = {"container":"_3gtm5F3f-3OV3Q-OVQ9v21"};